import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuButton, NeuCard } from "../../components/neu/Neu";
import { saveTokenPricing, tokenPricing } from "../../api/wallet";
import { TokenPricingFields } from "./TokenPricingFields";
import { usePerms } from "../../hooks/usePerms";

export const TokenPricingSettings = () => {
  const { t } = useTranslation();
  const [config, setConfig] = useState(null);
  const canBilling = usePerms().can("billing");

  useEffect(() => {
    if (!canBilling) return;
    (async () => setConfig(await tokenPricing()))();
  }, [canBilling]);

  if (!config || !canBilling) return null;

  const set = (key, value, numeric) => setConfig({ ...config, [key]: numeric ? Number(value) : value });

  const setPackages = (raw) =>
    setConfig((c) => ({
      ...c,
      packages: raw.split(",").map((v) => Number(v.trim())).filter((v) => v > 0),
    }));

  const setTier = (index, key, value) =>
    setConfig((c) => ({
      ...c,
      aws_tiers: c.aws_tiers.map((tier, i) =>
        i === index ? { ...tier, [key]: value === "" ? null : Number(value) } : tier
      ),
    }));

  const setLivenessTier = (index, key, value) =>
    setConfig((c) => ({
      ...c,
      liveness_tiers: (c.liveness_tiers || []).map((tier, i) => (i === index ? { ...tier, [key]: value } : tier)),
    }));

  const save = async () => {
    try {
      await saveTokenPricing(config);
      toast.success(t("tokens.saved"));
    } catch {
      toast.error(t("errors.generic"));
    }
  };

  return (
    <NeuCard data-testid="token-pricing-settings">
      <p className="label-xs">{t("tokens.pricingEngine")}</p>
      <TokenPricingFields
        config={config}
        set={set}
        setPackages={setPackages}
        setTier={setTier}
        setLivenessTier={setLivenessTier}
      />
      <NeuButton variant="primary" className="mt-5" data-testid="token-pricing-save" onClick={save}>
        {t("tokens.save")}
      </NeuButton>
    </NeuCard>
  );
};
